export default "<div class=\"scroll-container\">\n  <ng-content></ng-content>\n</div>\n";